module.exports = __webpack_public_path__ + "static/media/Huynh_Manh_Tuong_Resume.9c7a1157.pdf";